CompanyListApp.Views.CompanyTable = Backbone.View.extend({

    initialize: function() {
        var self = this;
        $.ajax({
            url: '/assets/js/company-list/templates/company-table.html',
            success: function(extTemplate) {
                self.template = _.template(extTemplate);
                $('div.company-list').append(self.$el);

                $.ajax({
                    url: '/assets/js/company-list/templates/company-row.html',
                    success: function(extTemplate) {
                        CompanyListApp.Templates.CompanyRow = _.template(extTemplate);
                        self.render();
                        self.collection.on('unshift', self.createRowView);
                    },
                    dataType: 'html',
                    cache: false
                });

            },
            dataType: 'html',
            cache: false
        });

    },

    render: function() {
        var self = this;
        this.$el.html(this.template());
        this.collection.forEach(self.createRowView, this);
        return this;
    },

    createRowView: function(companyModel) {
        new CompanyListApp.Views.CompanyRow({model: companyModel, id: companyModel.attributes.id});
    }

});